import { render, staticRenderFns } from "./LoginDashboardPopupPlatform.vue?vue&type=template&id=74820228"
import script from "./LoginDashboardPopupPlatform.vue?vue&type=script&lang=js"
export * from "./LoginDashboardPopupPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports